<div class="quick-actions-main-container">
  <span class="project-name">{{cardData?.project.name}}</span>
  <ng-container *ngIf="vm$ | async as vm; else loading">
    <span class="user-label">{{'project_team_dashboard_edit_team_leader_label' | translate}}</span>
    <div class="project-manager-container">
      <img class="leader-icon"
           [src]="(cardData?.project.leader.user?.avatar?.path !== null) ?
                   baseUrl+cardData?.project.leader.user.avatar.path : '../../../assets/svg/user-icon.svg'">
      <span class="leader-name-text edit-team-name-text">
        {{(cardData?.project.leader.user.detail.firstname || cardData?.project.leader.user.detail.lastname) ?
          cardData?.project.leader.user.detail.firstname+' '+cardData?.project.leader.user.detail.lastname :
          cardData?.project.leader.user.email}}</span>
    </div>
  </ng-container>
  <ng-template #loading>
    <div class="spinner-border text-primary categ-statement-spinner" role="status"></div>
  </ng-template>
</div>
